// extracted by mini-css-extract-plugin
module.exports = {"Heading":"Apply_Heading__2_j13","ApplyForm":"Apply_ApplyForm__UqKN5"};